module.exports = {
  INSERT_NODE:  0,
  CREATE_NODE:  1,
  UPDATE_NODE:  2,
  REPLACE_NODE: 3,
  DELETE_NODE:  4,
}



// WEBPACK FOOTER //
// ../node_modules/vqua/lib/constants/actionTypes.js